import { FC, useEffect } from 'react';
import Layout from '@components/primitives/layout/Layout';
import { matchPath, Outlet, useLocation } from 'react-router-dom';
import { DEFAULT_LIST_TYPE, PagePath } from '@routing/appUrls';
import useFetchDocClasses from '@components/features/docClass/hooks/useFetchDocClasses';
import useFetchDocList from '@components/features/docList/hooks/useFetchDocList';
import Content from '@components/primitives/content/Content';
import { useAtomValue } from 'jotai';
import { currentDocClassAtom } from '@js/store/appAtoms';
import useExternalModalSignals from '@components/pages/modalExternalViewPage/hooks/useExternalModalSignals';
import ApplicationModals from '@components/modals/ApplicationModals';

const pagePathsWithoutApplicationModals = [PagePath.documentExternalView, PagePath.modalExternalView];

const PrivateRoutes: FC = () => {
    const currentDocClass = useAtomValue(currentDocClassAtom);
    const { isSuccess: docClassesFetched } = useFetchDocClasses();
    const { isSuccess: docListFetched } = useFetchDocList(currentDocClass, DEFAULT_LIST_TYPE, { refetchOnWindowFocus: false });

    const pageReadyToDisplay = docClassesFetched && docListFetched;
    const location = useLocation();
    const showApplicationModals = !pagePathsWithoutApplicationModals.some((pathPattern) => matchPath({ path: pathPattern, end: false }, location.pathname));
    const { listen } = useExternalModalSignals();

    useEffect(() => {
        if (showApplicationModals) {
            listen();
        }
    }, [showApplicationModals]);

    return (
        <Layout>
            {pageReadyToDisplay ? <Outlet /> : <Content>{/*<Throbber />*/}</Content>}
            {showApplicationModals && <ApplicationModals />}
        </Layout>
    );
};

export default PrivateRoutes;
